import React, { useEffect, useState } from "react";
import { api, apiError } from "@/lib/api";
import { toast } from "@/components/ui/sonner";

export default function Logs() {
  const [data, setData] = useState({ logs: [], total: 0 });
  const [page, setPage] = useState(1);

  const load = async (p = 1) => {
    try {
      const { data } = await api.get("/admin/logs", { params: { page: p, limit: 30 } });
      setData(data);
      setPage(p);
    } catch (e) { toast.error(apiError(e)); }
  };
  useEffect(() => { load(1); }, []);

  return (
    <div data-testid="admin-logs">
      <h1 className="text-3xl font-black font-heading text-slate-900 tracking-tighter">Admin Audit Logs</h1>
      <p className="text-sm text-slate-500 mt-1">{data.total} actions recorded. Every administrative change is tracked.</p>
      <div className="mt-6 bg-white border border-slate-200 rounded-xl overflow-hidden">
        <table className="w-full text-sm">
          <thead>
            <tr className="bg-slate-50 text-[10px] font-bold tracking-[0.15em] uppercase text-slate-400 border-b border-slate-200">
              <th className="text-left px-5 py-3">Time (IST)</th><th className="text-left px-5 py-3">Admin</th><th className="text-left px-5 py-3">Action</th><th className="text-left px-5 py-3">Target</th><th className="text-left px-5 py-3">IP</th>
            </tr>
          </thead>
          <tbody className="divide-y divide-slate-100">
            {data.logs.map((l) => (
              <tr key={l.id} data-testid={`log-row-${l.id}`}>
                <td className="px-5 py-3 text-xs text-slate-400 whitespace-nowrap">{l.ts ? new Date(l.ts).toLocaleString("en-IN", { timeZone: "Asia/Kolkata" }) : "—"}</td>
                <td className="px-5 py-3 font-semibold text-slate-700">{l.admin}</td>
                <td className="px-5 py-3"><span className="text-[10px] font-bold uppercase tracking-wider px-2 py-1 rounded-full bg-[#FF9933]/10 text-[#E6892E]">{l.action}</span></td>
                <td className="px-5 py-3 text-xs text-slate-500 max-w-[220px] truncate">{l.target}</td>
                <td className="px-5 py-3 text-xs text-slate-400">{l.ip}</td>
              </tr>
            ))}
            {data.logs.length === 0 && <tr><td colSpan={5} className="px-5 py-12 text-center text-slate-400">No admin actions logged yet.</td></tr>}
          </tbody>
        </table>
        <div className="px-5 py-3 border-t border-slate-100 flex items-center justify-between">
          <button disabled={page <= 1} onClick={() => load(page - 1)} data-testid="logs-prev" className="text-sm font-bold text-slate-500 disabled:opacity-30">← Prev</button>
          <span className="text-xs text-slate-400 font-semibold">Page {page}</span>
          <button disabled={data.logs.length < 30} onClick={() => load(page + 1)} data-testid="logs-next" className="text-sm font-bold text-slate-500 disabled:opacity-30">Next →</button>
        </div>
      </div>
    </div>
  );
}
